module.exports = __webpack_public_path__ + "img/transglobal-logo.13a1b52b.jpg";